import React from 'react';

export type Props = {
  href: string;
};

export const AsyncStylesheet = React.memo((props: Props) => {
  const {
    href,
  } = props;

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `<link rel='stylesheet' media='print' href=${href} onload='this.media="all"'/>`,
      }}
    />
  );
});

AsyncStylesheet.displayName = 'AsyncStylesheet';
